import { eChuongTrinhDaoTaoKienThucActionsObj } from "./../../action-types/category/IChuongTrinhDaoTaoKienThucActions";
import { NotifyHelper } from "../../../helpers/toast";
import { generateActionForKey, generateActions } from "../generateActions";

export const chuongTrinhDaoTaoKienThucActions = {
  ...generateActions(
    eChuongTrinhDaoTaoKienThucActionsObj,
    "CHUONG_TRINH_DAO_TAO_KIEN_THUC"
  ),
};
